const state = {
    iframeShown: false,
    ipBuyId: '',
    ipRole: {},
    role: {}
}

const getters = {
    iframeShown: state => state.iframeShown,
    ipBuyId: state => state.ipBuyId,
    ipRole: state => state.ipRole,
    role: state => state.role
}

const mutations = {
    set_iframeShown (state, data) {
        state.iframeShown = data
    },
    set_ipBuyId (state, data) {
        state.ipBuyId = data
    },
    set_ipRole (state, data) {
        state.ipRole = data
    },
    set_role (state, data) {
        state.role = data
    }
}

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/IPRolePay.js